/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { RouteWithResources } from '../../../../../common/types.tsx';

export const routeHasResources = (route: RouteWithResources | null): boolean =>
	!!(route && route.resources && route.resources.length > 0);

export const routeHasChanged = (prev: RouteWithResources, next: RouteWithResources): boolean =>
	prev.name !== next.name || prev.path !== next.path;
